var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-actions',{staticClass:"plot-footer",class:{
        'absolute-layout': _vm.absoluteLayoutType.includes(_vm.type),
        'justify-center': _vm.type === 'plot-grid'
    }},[_c('v-btn',{staticClass:"habiteo-btn promoter-customization text-capitalize",class:{
            'xs': _vm.$vuetify.breakpoint.xs,
            'mr-4': _vm.$vuetify.breakpoint.mdAndUp,
        },attrs:{"id":"gtm-plotcard-cta-discover","outlined":"","small":""},on:{"click":function($event){$event.preventDefault();return _vm.updateWidget(_vm.data)}}},[_vm._v("\n        "+_vm._s(_vm.$t('widgets.plot.discover'))+"\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1abcd9f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plotInformation/layout/PlotFooter.vue
// module id = null
// module chunks = 